import {Box, Button, styled} from "@mui/material";
import {color} from "../../theme/includes/color";


export const FooterBoardContainer = styled(Box)({
  width: "100%",
  backgroundColor: color('grey-300'),
  padding: "40px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",

  marginTop: 'auto'
})

export const FooterBoardBox = styled(Box)({
  display: "flex",
  gap: '8px'
})

export const FooterBoardButton = styled(Button)({
  width: "100%",
  height: "48px",
  minWidth: "340px",
  backgroundColor: color('grey-600'),
  color: color('black-100'),
  borderRadius: '16px',
  border: '2px solid transparent',
  '&:hover': {
    borderColor: color('grey-400'),
    backgroundColor: color('grey-600'),
  }
})



